import React from 'react';

export const PostHogLogo: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <div className="w-8 h-8 flex items-center justify-center">
    <svg
      {...props}
      viewBox="0 0 300 300"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-full h-full"
    >
      <path fill="#fff" d="M0 0h300v300H0z" />
      <path
        fill="#F9BD2B"
        d="m33 179.379 39.004 38.951H33zm0-9.738 48.755 48.689h39.004L33 130.689zm0-48.69 97.51 97.379h39.003L33 82zm48.755 0 97.509 97.379v-38.951L81.754 82zM130.51 82v38.951l48.754 48.69v-38.952z"
      />
      <path
        fill="#000"
        d="M267.023 202.75a37.7 37.7 0 0 1-26.632-11.016l-54.231-54.158v80.754h80.863z"
      />
      <path
        fill="#fff"
        d="M209.563 202.75c4.308 0 7.8-3.488 7.8-7.791 0-4.302-3.492-7.79-7.8-7.79-4.309 0-7.801 3.488-7.801 7.79 0 4.303 3.492 7.791 7.801 7.791"
      />
      <path
        fill="#1D4AFF"
        d="M33 218.33h39.004L33 179.379zm48.755-87.641L33 82v38.951l48.755 48.69zm-48.755 0v38.952l48.755 48.689v-38.951z"
      />
      <path
        fill="#F54E00"
        d="M130.51 130.689 81.755 82v38.951l48.755 48.69zM81.755 218.33h39.004l-39.004-38.951zm0-87.641v38.952l48.755 48.689v-38.951z"
      />
    </svg>
  </div>
);
